// eslint-disable-next-line no-restricted-imports
export { CircularProgress } from '@material-ui/core';
